import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Container, Divider, Paper, Stack } from '@mui/material';
import { t } from "i18next";
import TwoFacIcon from '../../../assets/2fac-faq.png';
import TradeIcon from '../../../assets/play_film.png';
import VarizBardashIcon from '../../../assets/money_icon.png';
import BuySellIcon from '../../../assets/buy_sell_icon_guid.png';
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import './AccardionGuidSections.css'
import UserRegisterIcon from '../../../assets/user_icon_guid.png';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import { Link } from 'react-router-dom';
import YesIcon from '../../../assets/yes_guid.png';
import NoIcon from '../../../assets/no_guid.png';




const TabPanel1 = styled(TabPanelUnstyled)`
    width: 100%;
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
  `;

const StyledTabs = styled(Tabs)(({ theme }) => {
    return {
        display: 'inline-flex',
        '& .MuiTabs-indicator': {
            left: '12%',
            right: 'unset',
            backgroundColor: '#ff3dff'
        },
        '& 	.MuiTabs-flexContainer': {
            paddingLeft: '15px'
        }
    };
});
const StyledTab = styled(Tab)(({ theme }) => {
    return {

        '&.Mui-selected': {
            color: '#ff3dff'
        }
    };
});


function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}



export function ControlledAccordions() {
    const [expanded, setExpanded] = React.useState<string | false>('panel1');

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };


    const [value, setValue] = React.useState(0);

    const handleChange1 = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };



    return (
        <Box sx={{ justifyContent: 'space-between', bgcolor: 'background.default', borderRadius: '10px' }}>
            <Box     >
                <Accordion disableGutters className='accardion_parent' sx={{ borderRadius: '10px !important', boxShadow: 'none', bgcolor: 'background.default' }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                    <AccordionSummary
                        className='accardion-summary-guid'
                        expandIcon={<KeyboardArrowLeftOutlinedIcon sx={{ m: 3 }} />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                        sx={{ borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Box sx={{ width: '1.5rem' }}>
                            <img src={UserRegisterIcon} width="100%" />
                        </Box>
                        <Typography sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                            {t('register_and_auth')}
                        </Typography>

                    </AccordionSummary>
                    <AccordionDetails sx={{ display: "flex", p: 0 }} >

                        <StyledTabs
                            className='tabs-accardion-guid-sections'
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange1}
                            aria-label="Vertical tabs example 1"
                            sx={{ textAlign: 'right' }}
                        >
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('how_to_auth')}`}{...a11yProps(0)} />
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('user_levels')}`} {...a11yProps(1)} />
                        </StyledTabs>

                    </AccordionDetails>
                </Accordion>
                <Accordion disableGutters className='accardion_parent' sx={{ borderRadius: '10px !important', boxShadow: 'none', bgcolor: 'background.default' }} expanded={expanded === 'panel2'} onChange={handleChange('panel2')} >
                    <AccordionSummary
                        className='accardion-summary-guid'
                        expandIcon={<KeyboardArrowLeftOutlinedIcon sx={{ m: 3 }} />}
                        aria-controls="panel2bh-content"
                        id="panel1bh-header"
                        sx={{ borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Box sx={{ width: '1.5rem' }}>
                            <img src={TwoFacIcon} width="100%" />
                        </Box>
                        <Typography sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                            {t('register_and_auth')}
                        </Typography>

                    </AccordionSummary>
                    <AccordionDetails sx={{ display: "flex", p: 0 }} >

                        <StyledTabs
                            className='tabs-accardion-guid-sections'
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange1}
                            aria-label="Vertical tabs example 2"
                            sx={{ textAlign: 'right' }}
                        >
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('how_to_auth')}`}{...a11yProps(0)} />
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('user_levels')}`} {...a11yProps(1)} />
                        </StyledTabs>

                    </AccordionDetails>
                </Accordion>
                <Accordion disableGutters className='accardion_parent' sx={{ borderRadius: '10px !important', boxShadow: 'none', bgcolor: 'background.default' }} expanded={expanded === 'panel3'} onChange={handleChange('panel3')} >
                    <AccordionSummary
                        className='accardion-summary-guid'
                        expandIcon={<KeyboardArrowLeftOutlinedIcon sx={{ m: 3 }} />}
                        aria-controls="panel3bh-content"
                        id="panel2bh-header"
                        sx={{ borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Box sx={{ width: '1.5rem' }}>
                            <img src={VarizBardashIcon} width="100%" />
                        </Box>
                        <Typography sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                            {t('harvest_deposit')}
                        </Typography>

                    </AccordionSummary>
                    <AccordionDetails sx={{ display: "flex", p: 0 }} >

                        <StyledTabs
                            className='tabs-accardion-guid-sections'
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange1}
                            aria-label="Vertical tabs example 3"
                            sx={{ textAlign: 'right' }}
                        >
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('how_to_auth')}`}{...a11yProps(0)} />
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('user_levels')}`} {...a11yProps(1)} />
                        </StyledTabs>

                    </AccordionDetails>
                </Accordion>
                <Accordion disableGutters className='accardion_parent' sx={{ borderRadius: '10px !important', boxShadow: 'none', bgcolor: 'background.default' }} expanded={expanded === 'panel4'} onChange={handleChange('panel4')} >
                    <AccordionSummary
                        className='accardion-summary-guid'
                        expandIcon={<KeyboardArrowLeftOutlinedIcon sx={{ m: 3 }} />}
                        aria-controls="panel4bh-content"
                        id="panel3bh-header"
                        sx={{ borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Box sx={{ width: '1.5rem' }}>
                            <img src={BuySellIcon} width="100%" />
                        </Box>
                        <Typography sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                            {t('buy_sell_arz')}
                        </Typography>

                    </AccordionSummary>
                    <AccordionDetails sx={{ display: "flex", p: 0 }} >

                        <StyledTabs
                            className='tabs-accardion-guid-sections'
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange1}
                            aria-label="Vertical tabs example 4"
                            sx={{ textAlign: 'right' }}
                        >
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('how_to_auth')}`}{...a11yProps(0)} />
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('user_levels')}`} {...a11yProps(1)} />
                        </StyledTabs>

                    </AccordionDetails>
                </Accordion>

                <Accordion disableGutters className='accardion_parent' sx={{ borderRadius: '10px !important', boxShadow: 'none', bgcolor: 'background.default' }} expanded={expanded === 'panel6'} onChange={handleChange('panel6')} >
                    <AccordionSummary
                        className='accardion-summary-guid'
                        expandIcon={<KeyboardArrowLeftOutlinedIcon sx={{ m: 3 }} />}
                        aria-controls="panel6bh-content"
                        id="panel5bh-header"
                        sx={{ borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <Box sx={{ width: '1.5rem' }}>
                            <img src={TradeIcon} width="100%" />
                        </Box>
                        <Typography sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                            {t('film')}
                        </Typography>

                    </AccordionSummary>
                    <AccordionDetails sx={{ display: "flex", p: 0 }} >

                        <StyledTabs
                            className='tabs-accardion-guid-sections'
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange1}
                            aria-label="Vertical tabs example 5"
                            sx={{ textAlign: 'right' }}
                        >
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('how_to_auth')}`}{...a11yProps(0)} />
                            <StyledTab sx={{ textAlign: 'right' }} label={`${t('user_levels')}`} {...a11yProps(1)} />

                        </StyledTabs>

                    </AccordionDetails>
                </Accordion>

            </Box>
        </Box>
    );
}

export default function GuidSectionsAccardion() {

    const [value, setValue] = React.useState(0);



    return (
        <Box sx={{ mx: 0, px: 0, py: 4, bgcolor: 'background.default' }} >
            <Container>

                <Box sx={{ pb: 3, pt: 0, display: 'flex' }}>
                    <TabsUnstyled defaultValue={value}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <TabPanel1 value={value} >
                                    <ControlledAccordions />
                                </TabPanel1>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>


                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', bgcolor: 'background.darkBlack', p: 1.4, borderRadius: '10px' }}>
                                    <Stack sx={{ p: 2 }}>
                                        <Typography variant='h6' sx={{ color: 'text.title', py: 1.5 }}>
                                            {t('register')}
                                        </Typography>
                                        <Divider flexItem />
                                        <ul className='ul_guid_section'>
                                            <li>
                                                <Typography variant='subtitle1' sx={{ color: 'text.title', py: 1.5 }}>
                                                    {t('lorem')}
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='subtitle1' sx={{ color: 'text.title', py: 1.5 }}>
                                                    {t('lorem')}
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='subtitle1' sx={{ color: 'text.title', py: 1.5 }}>
                                                    {t('lorem')}
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='subtitle1' sx={{ color: 'text.title', py: 1.5 }}>
                                                    {t('lorem')}
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant='subtitle1' sx={{ color: 'text.title', py: 1.5 }}>
                                                    {t('lorem')}
                                                </Typography>
                                            </li>
                                        </ul>
                                    </Stack>
                                    <Stack sx={{ p: 2 }}>
                                        <Typography variant='h6' sx={{ color: 'text.title', textAlign: 'center', py: 1.5 }}>
                                            {t('lorem').slice(0, 45)}
                                        </Typography>
                                        <Typography variant='subtitle1' sx={{ color: 'text.secondary', textAlign: 'center', py: 2.5 }}>
                                            {t('full_lorem')}
                                        </Typography>
                                        <Divider />
                                        <Stack justifyContent={'center'} spacing={1} mb={2}>
                                            <Typography variant='subtitle1' sx={{ color: 'text.secondary', textAlign: 'center', py: 1.5 }}>
                                                {t('was_it_good')}
                                            </Typography>
                                            <Stack direction={'row'} justifyContent={'center'} spacing={1} alignItems={'center'}>
                                                <Link to='/'>
                                                    <Box>
                                                        <img src={YesIcon} alt='yes icon' width='100%' />
                                                    </Box>
                                                </Link>
                                                <Link to='/'>
                                                    <Box>
                                                        <img src={NoIcon} alt='yes icon' width='100%' />
                                                    </Box>
                                                </Link>
                                            </Stack>
                                            <Stack direction={'row'} justifyContent={'center'} spacing={1} alignItems={'center'}>
                                                <Typography variant='subtitle1' sx={{ color: 'text.secondary', textAlign: 'start' }}>
                                                    {t('another_question')}
                                                </Typography>
                                                <Typography variant='subtitle1' sx={{ color: '#FCD535', textAlign: 'start' }}>
                                                    {t('send_ticket')}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                        <Divider />
                                        <Stack spacing={1.5} my={2.5}>
                                            <Typography variant='h6' sx={{ color: 'text.primary', textAlign: 'start' }}>
                                                {t('relatd_question')}
                                            </Typography>
                                            <Typography variant='h6' sx={{ color: '#FF3DFF', textAlign: 'start' }}>
                                                {t('lorem').slice(0 ,58) + '؟'}
                                            </Typography>
                                            <Typography variant='h6' sx={{ color: '#FF3DFF', textAlign: 'start' }}>
                                                {t('lorem').slice(0 ,58) + '؟'}
                                            </Typography>
                                            <Typography variant='h6' sx={{ color: '#FF3DFF', textAlign: 'start' }}>
                                                {t('lorem').slice(0 ,58) + '؟'}
                                            </Typography>
                                            <Typography variant='h6' sx={{ color: '#FF3DFF', textAlign: 'start' }}>
                                                {t('lorem').slice(0 ,58) + '؟'}
                                            </Typography>
                                            <Typography variant='h6' sx={{ color: '#FF3DFF', textAlign: 'start' }}>
                                                {t('lorem').slice(0 ,58) + '؟'}
                                            </Typography>
                                            
                                        </Stack>
                                    </Stack>

                                </Box>
                            </Grid>
                        </Grid>
                    </TabsUnstyled>
                </Box>
            </Container>
        </Box >
    );
}

